import * as React from 'react'

import Svg, { G, Mask, Path } from 'react-native-svg'

import { IconProps } from '../index'

const ChatSupport = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <Path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </Mask>
    <G mask="url(#a)">
      <Path
        fill="#88878F"
        d="M2 17V3c0-.283.096-.52.288-.712A.968.968 0 0 1 3 2h13c.283 0 .52.096.712.288.192.191.288.429.288.712v9c0 .283-.096.52-.288.713A.968.968 0 0 1 16 13H6l-4 4Zm5 1a.967.967 0 0 1-.713-.288A.968.968 0 0 1 6 17v-2h13V6h2c.283 0 .52.096.712.287.192.192.288.43.288.713v15l-4-4H7Zm8-14H4v8.175L5.175 11H15V4Z"
      />
    </G>
  </Svg>
)
export default ChatSupport
